import { render } from "./EmployeeProfile.vue?vue&type=template&id=56f7d739&scoped=true"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js"

import "./EmployeeProfile.vue?vue&type=style&index=0&id=56f7d739&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f7d739"]])

export default __exports__